import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Text from "@/components/common/Text";

/**
 * SP4c — Single button replacing the legacy username/password form. Clicking
 * redirects to Auth0 Universal Login (PKCE). On successful auth, Auth0
 * bounces back to `/auth/callback` which then navigates to `appState.returnTo`.
 */
export function Auth0LoginButton() {
  const { loginWithRedirect, isLoading } = useAuth0();
  const location = useLocation();
  const returnTo = (location.state as { path?: string } | null)?.path || "/";

  return (
    <div className="flex w-[391px] flex-col gap-8">
      <Text
        variant="heading_h4"
        className="text-center font-medium tracking-[-5%] text-shades-neutral-500"
      >
        Login Into Your Account
      </Text>
      <Button
        type="button"
        disabled={isLoading}
        onClick={() => loginWithRedirect({ appState: { returnTo } })}
        className="h-12 w-full"
      >
        Continue with Auth0
      </Button>
    </div>
  );
}
